import React from "react";
import { datadogLogs } from "@datadog/browser-logs";
import { FatalError } from "./FatalError/FatalError";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

function Fallback({ error, resetErrorBoundary }) {
  return <FatalError message={error.message} />;
}

export const notifyDatadogWithError = (error, info) => {
  datadogLogs.logger.error(
    "An error occurred in web-notes",
    {
      message: error?.message,
      stack: error?.stack,
      componentStack: info?.componentStack ?? error?.stack ?? ""
    },
    error
  );
};

const ErrorBoundary = ({ children }) => {
  const handleError = (error, info) => {
    datadogLogs.logger.error(
      "An error occurred in web-notes",
      {
        message: error?.message,
        stack: error?.stack,
        componentStack: info?.componentStack ?? error?.stack ?? ""
      },
      error
    );
  };

  return (
    <ReactErrorBoundary FallbackComponent={Fallback} onError={handleError}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
